import { api } from '../core/client';

/** Per-tenant app config (GET /api/ui/config) — accent, terminology & enabled screens by industry vertical. */
export interface ApiAppConfig {
  industry: 'restaurant' | 'kirana';
  brand: string;
  /** Uploaded brand logo URL (Settings → logo); empty = use the built-in logo. */
  logo: string;
  accent: string;
  accentName: string;
  /** Deep/secondary brand colour hex (garden forest green by default). */
  secondary: string;
  mode: string;
  lang: string;
  landing: string;
  terminology: Record<string, string>;
  enabledScreens: string[];
}

interface ApiEnvelope<T> {
  success: boolean;
  message: string | null;
  result: T;
}

export const configService = {
  /** Fetch the tenant config; pass an industry to preview a vertical without changing the outlet. */
  get(industry?: string): Promise<ApiAppConfig> {
    const q = industry ? `?industry=${encodeURIComponent(industry)}` : '';
    return api.get<ApiEnvelope<ApiAppConfig>>(`/ui/config${q}`).then((r) => r.data.result);
  },

  /**
   * Persist the tenant's vertical on its outlet and return the resulting config.
   *
   * `get(industry)` is only a preview: the next page load calls `get()` with no override, reads the
   * outlet's stored vertical, and snaps back — which is why switching to kirana never survived a
   * refresh. This is the call that makes it stick.
   */
  setIndustry(industry: string): Promise<ApiAppConfig> {
    return api
      .put<ApiEnvelope<ApiAppConfig>>('/ui/config/industry', { industry })
      .then((r) => r.data.result);
  }
};
